module.exports = __webpack_public_path__ + "static/media/plane.1fbbbf03.svg";